import { Pipe, PipeTransform } from '@angular/core';
import { ADD_ITEM_PREFIX } from './types';

@Pipe({
  name: 'removePrefix',
})
export class RemovePrefixPipe implements PipeTransform {
  transform(label: string): string {
    return label.startsWith(ADD_ITEM_PREFIX) ? label.replace(ADD_ITEM_PREFIX, '') : label;
  }
}
